import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface EditSupplierNameProps {
  show: boolean;
  onHide: () => void;
  supplierName: string;
  onSave: (newName: string) => void;
  loading?: boolean;
}

const EditSupplierName: React.FC<EditSupplierNameProps> = ({
  show,
  onHide,
  supplierName,
  onSave,
  loading = false,
}) => {
  const [name, setName] = useState<string>(supplierName);
  const [error, setError] = useState<boolean>(false);

  // Reset input when modal opens or supplierName changes
  useEffect(() => {
    setName(supplierName);
    setError(false);
  }, [supplierName, show]);

  const handleSave = () => {
    if (!name.trim()) {
      setError(true);
      return;
    }
    onSave(name.trim());
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Supplier Name</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            isInvalid={error}
            placeholder="Enter supplier name"
          />
          {error && (
            <Form.Text className="text-danger">
              Supplier name cannot be empty
            </Form.Text>
          )}
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={loading}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditSupplierName;
